import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { colors } from '@/theme/colors.theme'

import { sidebarClosedWidth, sidebarOpenWidth } from '@/constants/sidebar'

const { red, white, blue, paper2 } = colors

const useStyles = makeStyles()((theme: Theme) => {
  return {
    appBarWrapper: {
      width: '100%',
      display: 'block',
      position: 'relative',
      height: 79,
    },
    appBar: {
      paddingLeft: 25,
      paddingRight: 25,
      backgroundColor: colors.nav,
      height: 79,
      position: 'fixed',
      zIndex: 2,

      '&.open': {
        width: `calc(100% - ${sidebarOpenWidth}px)`,
      },

      '&.close': {
        width: `calc(100% - ${sidebarClosedWidth}px)`,
      },
    },
    barProfile: {
      paddingLeft: '15px',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    box: {
      '&:focus': {
        outline: 'none',
      },
    },
    logoutLink: {
      width: '100%',

      '&:hover': {
        color: white,
        backgroundColor: red,
        borderRadius: '0px !important',
      },
    },
    editProfile: {
      width: '100%',

      '&:hover': {
        color: white,
        backgroundColor: blue,
        borderRadius: '0px !important',
      },
    },
    boxBrand: {
      height: '48px',
      backgroundColor: paper2,
      width: '170px',
      borderRadius: '10px',
      marginTop: '14px',
    },
    selectBrand: {
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 13px) scale(1)',
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        transform: 'translate(14px, -2px) scale(0.75)',
      },
      '& .MuiAutocomplete-input': {
        color: white,
        fontSize: '15px',
        fontWeight: '700',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
  }
})

export default useStyles
